import StoreMix from '@lottery.2.0/mixin/store.js'
export default {
    name: 'Sign',
    mixins: [StoreMix],
    data() {
        return {
            store: 'base/line',
            isDev: process.env.NODE_ENV === 'development',
            params: {
                username: '', // 用户名
                pass: '', // 密码

                code: '1234', // 验证码
                otp_code: '',
                key: null,

                re_pass_word: '', // 确认密码
                email: '', // 邮箱
                mobile: '', // 手机号

                qq: '', // QQ
                recommend_code: '',
                recommend_name: ''
            },
            type: 'signin',
            time: null,
            verify: {
                check: false,
                image: null,
                loading: false
            },
            otpStep: false,
            otpToken: null
        }
    },
    computed: {
        canGetCode() {
            return this.checkPhone(this.params.username)
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.GetKey()
        },
        submit() {
            if (this[`submit_${this.type}`]) {
                this[`submit_${this.type}`]()
            }
        },
        submit_signin() {
            const payload = { ...this.params }
            if (this.otpStep && this.otpToken) {
                payload.otp_token = this.otpToken
                payload.code = this.params.otp_code
            }
            return this.$store.dispatch('base/BASE_SIGNIN', payload).then(res => {
                if (res.need_otp) {
                    this.otpStep = true
                    this.otpToken = res.otp_token
                    return
                }
                this.finishLogin(res)
            }, err => {
                if (this.otpStep) {
                    this.params.otp_code = ''
                } else {
                    this.params.pass = null
                    this.imgVerifyLoad()
                }
            })
        },
        finishLogin(res) {
            this.otpStep = false
            this.otpToken = null
            this.Toast('登录成功')
            this.Cache('token', res.token)
            if (res.redirect_url) {
                this.Login(true)
                window.location.href = res.redirect_url
                return
            }
            return this.Login(true)
        },
        cancelOtpStep() {
            this.otpStep = false
            this.otpToken = null
            this.params.otp_code = ''
        },
        submit_signup() {
            return this.$store.dispatch('base/BASE_SIGNUP', 'this.params').then(res => {
                return this.typeChange('signin')
            })
        },
        submit_forget() {

        },
        // 切换：登录、注册、忘记密码
        typeChange(type = 'signin') {
            this.type = type;
            this.DataReset('params');
            this.imgVerifyLoad()
        },
        imgVerifyLoad() {
            this.params.key = null
            if (this.$refs['verify']) {
                this.verify.check = false
                this.verify.loading = true
                this.Dp('base/IMAGE_VERIFY').then(res => {
                    this.verify.loading = false
                    this.verify.image = res.data
                    this.$refs['verify'].reset()
                })
            }
        }
    }
}
